export default __webpack_public_path__ + "static/media/GroupDescDark.23bc772c.png";